import { EDTF_TYPES } from '@shared/types/ImagingSpecialist';
import { d7Format } from '@shared/utils/date';

export const edtfMapper: (args: { type?: EDTF_TYPES; value?: string }) => string = ({
  type,
  value,
}) => {
  if (value === undefined || value === null || value === '') {
    return 'no data';
  }

  switch (type) {
    case EDTF_TYPES.date:
      return d7Format(value, 'dd-LLL-yyyy');
    case EDTF_TYPES['date-month']:
      return d7Format(value, 'MMM-yyyy');
    default:
      return String(value);
  }
};
